import { useRouter }                     from "next/router";
import { Fragment, useEffect, useState } from "react";

import { VideoPageTags }                          from "_common/seo";
import { initialValidations }                     from "_common/ssrWrapper";
import { enableBackupAPIsInCookies, getOptImage } from "_common/utils";
import ControlHeight                              from "_components/atoms/controlHeight";
import VideoDetail                                from "_components/pages/videos";
import { getFeedById, getSEOTags }                from "_services/api/feed";

function Videos ( props ) {
	const [ backupFeedData, setBackupFeedData ] = useState ( null );
	const [ isLoading, setIsLoading ]           = useState ( false );

	const feed    = backupFeedData ? backupFeedData : ( props?.feed || {} );
	const videoId = props?.videoId;
	const seoTags = props?.seoTags;
	const router  = useRouter ();

	const getBackupData = async () => {
		try {
			setIsLoading ( true );
			const result = await getFeedById ( { feedId: videoId } );

			setBackupFeedData ( result );
			setIsLoading ( false );

		} catch ( error ) {
			setIsLoading ( false );
			//
		}
	};

	useEffect ( () => {
		if ( Object.keys ( props?.feed || {} )?.length )
			return;

		enableBackupAPIsInCookies ();
		getBackupData ();
	}, [] );

	const { from, userId, previousRoute } = router.query;

	if ( isLoading ) return null;

	function getThumbnail ( mediaArr ) {
		if ( mediaArr?.length ) {
			const item = mediaArr.filter ( item => item.mediaType === "IMAGE" );

			return getOptImage ( item[0].href );
		}
	}

	const thumbnail = getThumbnail ( feed.media );
	const title     = feed.title;
	const userName  = feed.actorDetails?.name;
	const prevPath  = previousRoute || props?.previousPath;

	const videoURL = feed.media.find ( item => item.mediaSequence === "5" )?.href || "";

	return (
		<Fragment>

			<VideoPageTags
				createdAt = { props?.feed?.createdAt }
				endpoint = { props?.currentPath }
				seoTags = { seoTags }
				summary = { props?.feed?.summary }
				thumbnail = { thumbnail }
				userName = { userName }
				videoDuration = { props?.feed?.read_time }
				videoTitle = { title }
				videoURL = { videoURL }
			/>

			<VideoDetail
				key = { videoId }
				feedId = { videoId }
				from = { from }
				previousRoute = { prevPath }
				thumbnail = { thumbnail }
				userId = { userId }
				videoItem = { feed }
			/>

			<ControlHeight />
		</Fragment>
	);
}

const getServerSideProps = async context => initialValidations ( context, async defaultProps => {

	const { id }  = context.query;
	const videoId = parseInt ( id );

	if ( !id || !videoId )
		return {
			notFound: true
		};

	let seoTags, pageName = "videoPage";

	const results = await Promise.allSettled (
		[
			getFeedById.bind ( defaultProps ) ( { feedId: videoId } ),
			getSEOTags.bind ( defaultProps ) ( { pageName } )

			/* getVideosList ( { pageNo: 1, pageSize: 10 } ) */
		]
	);

	let feed        = null;
	let forceLogout = false;

	results.forEach ( ( result, index ) => {
		if ( result.status === "fulfilled" ) {
			switch ( index ) {
				case 0:
					feed = result.value;
					break;

				case 1:
					seoTags = result.value;
					break;
			}
		}

		if ( result.status === "rejected" && result.reason?.message === "TOKEN_EXPIRED_FORCE_LOGOUT" )
			forceLogout = true;
	} );

	if ( forceLogout )
		return {
			redirect: {
				destination : `/logout?forceLogout=${ true }&prevLocation=${ defaultProps?.currentPath }`,
				permanent   : false
			}
		};

	if ( !feed )
		return {
			notFound: true
		};

	if ( !defaultProps?.isLoggedIn )
		context.res.setHeader (
			"Cache-Control",
			"public, s-maxage=90, stale-while-revalidate=120"
		);

	return { props: { ...defaultProps, feed, videoId, seoTags: seoTags?.seo_tags || [] } };
}, { blockOBS: true } );

export { getServerSideProps };

export default Videos;
